import { render, staticRenderFns } from "./TextObjectTable.vue?vue&type=template&id=4998aa21&"
import script from "./TextObjectTable.vue?vue&type=script&lang=ts&"
export * from "./TextObjectTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports